import React, { FC } from 'react';
import classes from './styles/index.module.scss';
import classNames from 'classnames';
import { Refresh } from '../Icons/Refresh';

type CloakLoadingProps = {
	className?: string;
	size?: 'tiny' | 'small' | 'medium';
	fixed?: boolean;
	noBackground?: boolean;
	inline?: boolean;
};

const CloakLoading: FC<React.PropsWithChildren<CloakLoadingProps>> = ({
	className = '',
	size = 'medium',
	fixed,
	noBackground,
	inline,
}) => {
	const componentClasses = classNames(classes.cloakLoading, className, classes[`cloakLoading_${size}`], {
		[classes.cloakLoading_fixed]: fixed,
		[classes.cloakLoading_inline]: inline,
		[classes.cloakLoading_noBackground]: noBackground,
	});

	const handleComponentClick = (e) => {
		e.stopPropagation();
	};

	return (
		<div
			className={componentClasses}
			onClick={handleComponentClick}
			data-testid='cloakLoading'
		>
			<Refresh className={classes.refreshIcon} />
		</div>
	);
};

export { CloakLoading };
